"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndexDependencies = void 0;

var _dependenciesImmutableDenseMatrixClassGenerated = require("./dependenciesImmutableDenseMatrixClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var IndexDependencies = {
  ImmutableDenseMatrixDependencies: _dependenciesImmutableDenseMatrixClassGenerated.ImmutableDenseMatrixDependencies,
  createIndexClass: _factoriesAny.createIndexClass
};
exports.IndexDependencies = IndexDependencies;